export default class Region {
	constructor() {
		this.root = document.querySelector('#container.region');
		this.map_item = this.root.querySelectorAll('.map-imgs__item');
		this.map_btn = this.root.querySelectorAll('.map-imgs__item__btn');
		this.group = this.root.querySelectorAll('.map-group');
		this.lang = this.root.querySelectorAll('.lang');
		this.addListeners();
	}

	addListeners() {
		for (let i = 0, l = this.map_btn.length; i < l; i++) {
			this.map_btn[i].addEventListener('click', this.mapSelect.bind(this), false);
		}
	}

	mapSelect(e) {
		const map_item = e.currentTarget.parentNode;
		const cls_name = 'map-imgs__item--selected';

		if (!map_item.classList.contains(cls_name)) {
			for (let i = 0, l = this.map_item.length; i < l; i++) {
				this.map_item[i].classList.remove(cls_name);
			}
		}

		map_item.classList.toggle(cls_name);

		if (map_item.classList.contains('map-group')) {
			for (let i = 0, l = this.group.length; i < l; i++) {
				if (map_item.classList.contains(cls_name)) {
					this.group[i].classList.add(cls_name);
				} else {
					this.group[i].classList.remove(cls_name);
				}
			}
		}

		this.showLang();
	}

	showLang() {
		const selected = this.root.querySelector('.map-imgs__item--selected');
		const lang = this.root.querySelectorAll('.lang');

		for (let i = 0, l = lang.length; i < l; i++) {
			lang[i].classList.remove('lang--show');
		}

		if (selected) {
			const selected_data = selected.getAttribute('data-show');

			this.root.querySelector(`.lang[data-lang="${selected_data}"]`).classList.add('lang--show');
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/module/Region.js